export default __webpack_public_path__ + "47ee636f4343693e8687d8de00e98e67.png";